import React from 'react'

interface UsageInfoModalProps {
  isOpen: boolean
  onClose: () => void
}

export const UsageInfoModal: React.FC<UsageInfoModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 p-2">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-lg border border-slate-200">
        <div className="flex items-center justify-between px-4 py-3 border-b">
          <h2 className="text-base font-semibold text-slate-800">How to use the calendar</h2>
          <button type="button" onClick={onClose} className="px-3 py-1.5 text-sm font-medium rounded-md border-2 border-red-500 text-red-600 bg-white hover:bg-red-50 transition-colors">Close</button>
        </div>
        <div className="px-5 py-4 text-slate-700">
          <ul className="list-disc pl-5 space-y-3 text-sm">
            <li>
              <span className="font-semibold text-sky-600">Single click</span> on an unmarked day <span className="font-semibold text-emerald-600">assigns care</span> to the caregiver selected in the top navigation (Home A / Home B).
            </li>
            <li>
              <span className="font-semibold text-sky-600">Single click</span> on a day that already has care, a note, or an expense — only <span className="font-semibold text-emerald-600">selects that day</span> and shows the list of entries below the calendar.
            </li>
            <li>
              <span className="font-semibold text-sky-600">Double click</span> on a day <span className="font-semibold text-emerald-600">opens the panel</span> to assign care / add a note/expense (in Pro plan). Instead of double-clicking, you can also use the <span className="font-semibold text-emerald-600">"Add"</span> button.
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}

export default UsageInfoModal
